import { buildProps, definePropType } from '@ll-plus/utils'

import Color from './color'

import type { ExtractPropTypes } from 'vue'

import type PreDefine from '../components/pre-define.vue'

export const parseColors = (colors: Color[], color: Color): Color[] => {
  return colors.map(value => {
    const c = new Color()
    c.enableAlpha = true
    c.format = 'rgba'
    c.fromString(value)
    c.selected = c.value === color.value
    return c
  })
}

export const preDefineProps = buildProps({
  colors: {
    type: definePropType<Color[]>(Array),
    required: true
  },
  color: {
    type: definePropType<Color>(Object),
    default: () => new Color()
  }
} as const)

// props
export type PreDefineProps = ExtractPropTypes<typeof preDefineProps>

// instance
export type PreDefineInstance = InstanceType<typeof PreDefine>
